<template>
  <div class="page-body">
    <div class="container-fluid">
      <div class="edit-profile">
        <div class="row">
          <div class="col-12 col-xl-12">
            <div class="card">
              <div class="card-header">
                <div class="text-neutral-500 text-xl font-medium font-['Poppins'] leading-normal">
                  {{ reasonId && reasonId !== '' ? "Editar Motivo" : "Crear Motivo" }}
                </div>
              </div>
              <div class="card-body" style="margin-top: 20px;">
                <form @submit.prevent="submitForm">
                  <div class="flex flex-col md:flex-row gap-4 md:gap-8">
                    <!-- ID y Nombre -->
                    <div class="flex flex-col gap-4 w-full md:w-[300px]">
                      <div class="w-full h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                        <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Nombre</label>
                        <input 
                          type="text" 
                          v-model="form.name"
                          class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                          placeholder="Nombre del motivo" 
                          @input="validateName"
                        />
                        <!-- Alerta para nombre -->
                        <div v-if="showNameAlert" class="required-alert">
                          <div class="yellow-box">!</div>
                          <span>Completa este campo</span>
                        </div>
                      </div>
                    </div>
                    <!-- Descripción -->
                    <div class="w-full md:w-[716px] h-[168px] flex-col justify-start items-start gap-1.5 inline-flex">
                      <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Descripción</label>
                      <textarea 
                        v-model="form.description"
                        class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                        placeholder="Descripción del motivo" 
                        @input="validateDescription"
                      ></textarea>
                      <!-- Alerta para descripción -->
                      <div v-if="showDescriptionAlert" class="required-alert">
                        <div class="yellow-box">!</div>
                        <span>Añade una descripción</span>
                      </div>
                    </div>
                  </div>
                  <!-- Botón -->
                  <div class="form-footer flex sm:flex-row mt-4">
                    <button type="button" class="custom-cancel-btn w-full sm:w-auto" @click="cancelChanges">
                      <span class="custom-cancel-btn-text">Cancelar</span>
                    </button>
                    <button type="submit" class="custom-create-btn w-full sm:w-auto" :disabled="isSubmitting"
                    :class="{ 'disabled-button': isSubmitting }">
                      <span class="custom-create-btn-text">{{ isSubmitting ? 'Guardando...' : 'Guardar' }}</span>
                    </button>
                  </div>
                </form>
              </div>
              <!-- Mensaje de éxito -->
              <div v-if="successMessage" class="user-alert">
                <div class="user-alert-content">
                  <div class="user-alert-text">
                    {{ successMessage }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";

export default {
  name: 'ReasonFormView',
  setup() {
    const store = useStore();
    const session = computed(() => store.getters.getUserSession);
    const route = useRoute();
    const router = useRouter();
    
    const reasonId = computed(() => route.params.id);  // Obtener el ID del motivo desde la URL
    const isSubmitting = ref(false);
    const form = ref({
      name: "",
      description: ""
    });
    const successMessage = ref("");
    const showNameAlert = ref(false);
    const showDescriptionAlert = ref(false);

    // Función para validar el nombre
    const validateName = () => {
      if (form.value.name.trim() !== '') {
        showNameAlert.value = false;
      }
    };
    
    // Función para validar la descripción
    const validateDescription = () => {
      if (form.value.description.trim() !== '') {
        showDescriptionAlert.value = false;
      }
    };

    // Función para cargar los datos del motivo cuando estamos en modo de edición
const loadReasonData = async () => {
  if (reasonId.value) {
    try {
      const token = session.value.token_api;
      if (!token) {
        console.error("No se ha encontrado el token de autenticación.");
        return;
      }

      const options = {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      };

      // Hacer la solicitud GET para obtener los datos del motivo
      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/catalogue-reports/${reasonId.value}`, 
        options
      );

        console.log('Respuesta de la API:', response.data);
      
      if (response.status === 200) {
        // Asignar los datos al formulario - AHORA LA RESPUESTA VIENE EN response.data.resp
         console.log('Datos recibidos:', response.data.resp);
        form.value.name = response.data.resp.name || "";
        form.value.description = response.data.resp.description || "";
        console.log('Formulario después de cargar:', form.value);
      }
    } catch (error) {
      console.error("Error al cargar los datos del motivo:", error);
      if (error.response?.status === 404) {
        alert("Motivo no encontrado. Puede que haya sido eliminado.");
        router.push({ name: "reports_reasons_list" });
      }
    }
  }
};

    // Llamar a la función cuando el componente se monta
    onMounted(() => {
      loadReasonData();
    });

    // Limpiar todas las alertas
    const submitForm = async () => {
  
  // Validar campos antes de enviar
  let isValid = true;
  
  if (form.value.name.trim() === '') {
    showNameAlert.value = true;
    isValid = false;
  } else {
    showNameAlert.value = false;
  }
  
  if (form.value.description.trim() === '') {
    showDescriptionAlert.value = true;
    isValid = false;
  } else {
    showDescriptionAlert.value = false;
  }
  
  if (!isValid) { 
    return; // Detiene el envío si hay campos inválidos
  }

  if (isSubmitting.value) return; // Evita múltiples envíos
  isSubmitting.value = true;

  try {
    const token = session.value.token_api;
    if (!token) {
      console.error("No se ha encontrado el token de autenticación.");
      isSubmitting.value = false;
      return;
    }

    const options = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    };

    const endpoint = reasonId.value
      ? `${process.env.VUE_APP_API_BASE_URL}/catalogue-reports/${reasonId.value}`
      : `${process.env.VUE_APP_API_BASE_URL}/catalogue-reports`;
    
    // Usar PUT para actualizar y POST para crear
    const method = reasonId.value ? "put" : "post";
    
    const dataToSend = { 
      name: form.value.name,
      description: form.value.description
    };

    // Hacer la solicitud para guardar o actualizar el motivo
    const response = await axios[method](endpoint, dataToSend, options);

    // Verificar respuesta exitosa (201 para creación, 200 para actualización)
    if (response.status === 200 || response.status === 201) {
      successMessage.value = reasonId.value 
        ? "Motivo actualizado con éxito." 
        : "Motivo creado con éxito.";

      // Limpiar el formulario si es un nuevo motivo
      if (!reasonId.value) {
        form.value.name = "";
        form.value.description = "";
      }

      setTimeout(() => {
        successMessage.value = "";
        router.push({ name: "reports_reasons_list" });
      }, 2000);
    }
  } catch (error) {
    console.error("Error al guardar el motivo:", error);
    if (error.response) {
      console.error("Error de servidor:", error.response.data);
      
      // Mostrar mensajes de error más específicos
      if (error.response.status === 422) {
        // Error de validación
        const errors = error.response.data.errors;
        let errorMessage = "Errores de validación:";
        
        for (const field in errors) {
          errorMessage += `\n- ${errors[field].join(', ')}`;
        }
        
        alert(errorMessage);
      } else if (error.response.status === 404) {
        alert("Motivo no encontrado. Puede que haya sido eliminado.");
      } else if (error.response.status === 500) {
        alert("Error del servidor: " + (error.response.data.message || "Error interno"));
      } else {
        alert("Error al guardar el motivo: " + 
          (error.response.data.message || "Error desconocido"));
      }
    } else {
      alert("Error de conexión. Verifica tu conexión a internet.");
    }
  } finally {
    isSubmitting.value = false; 
  }
};

    const cancelChanges = () => {
      router.push({ name: "reports_reasons_list" });
    };

    return {
      reasonId,
      form,
      submitForm,
      successMessage,
      showNameAlert,
      showDescriptionAlert,
      validateName,
      validateDescription,
      isSubmitting,
      cancelChanges
    };
  }
};
</script>

<style scoped>
.required-alert {
  display: flex;
  align-items: center;
  background-color: #fff;
  color: #333;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-top: 5px;
  position: relative;
  max-width: 300px;
  word-wrap: break-word;
}

.required-alert .yellow-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background-color: #e59035;
  margin-right: 10px;
  border: 1px solid #e59035;
  border-radius: 4px;
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  line-height: 1;
}

.required-alert::after {
  content: "";
  position: absolute;
  top: -10px;
  left: 20px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #fff;
  z-index: 1;
}

.required-alert::before {
  content: "";
  position: absolute;
  top: -11px;
  left: 19px;
  width: 0;
  height: 0;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-bottom: 11px solid #ccc;
  z-index: 0;
}

.custom-cancel-btn {
  display: inline-flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: #4B5563;
  border: 1px solid #4B5563;
  color: white;
  cursor: pointer;
  margin-right: 10px;
  transition: all 0.3s ease;
}

.custom-cancel-btn-text {
  color: #FFF;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.form-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.custom-create-btn {
  display: inline-flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: #ff4265;
  border: 1px solid #ff4265;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
}

.custom-create-btn-text {
  color: #FFF;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  width: 100%;
}

.disabled-button {
  opacity: 0.5;
  cursor: not-allowed;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Estilos responsivos */
@media (max-width: 767px) {
  .card-body {
    padding: 15px;
  }
  
  .flex-col-mobile {
    flex-direction: column;
  }
  
  .w-full-mobile {
    width: 100% !important;
  }
  
  .space-x-4 {
    margin-left: 0;
    margin-right: 0;
  }
  
  .gap-8 {
    gap: 1rem;
  }
  
  .form-footer {
    flex-direction: column;
    gap: 10px;
  }
  
  .custom-cancel-btn, 
  .custom-create-btn {
    width: 100%;
    margin-right: 0;
    margin-bottom: 10px;
  }
}

@media (min-width: 768px) {
  .form-footer {
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>